import { Typography } from '@material-tailwind/react'
import { memo } from 'react'
import PropTypes from 'prop-types'
import { FiEdit2 } from 'react-icons/fi'
import { PageLayoutOverlay } from '.'
import { useNavigation } from 'react-router-dom'

export const PageLayout = memo(
  ({
    leftSection,
    rightSection,
    children,
    title,
    description,
    actions,
    editMode,
    className
  }) => {
    const { state } = useNavigation()
    return (
      <div
        className={className}
      >
        {state === 'loading' && <PageLayoutOverlay />}
        <div className='flex justify-between'>
          <div className='flex items-center gap-3'>
            <div className='flex flex-col gap-4'>
              <Typography variant='h4'>{title}</Typography>
              {description && <Typography variant='small' className='text-gray-500'>{description}</Typography>}
            </div>
            {editMode && (
              <div className='h-7 pl-3 pr-2.5 py-1 text-blue-700 bg-blue-50 rounded-2xl justify-center items-center gap-3 inline-flex'>
                <FiEdit2 />
                <Typography variant='small' className='font-medium'>
                  Estás editando una entrada
                </Typography>
              </div>
            )}
            {leftSection && leftSection}
          </div>

          <div className='flex items-center gap-4'>
            {rightSection && rightSection}
            <div className='flex items-center justify-between'>
              {actions && actions}
            </div>
          </div>
        </div>

        {children}
      </div>
    )
  }
)

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(PropTypes.node),
  editMode: PropTypes.bool,
  leftSection: PropTypes.node,
  rightSection: PropTypes.node,
  description: PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.bool
}

PageLayout.defaultProps = {
  actions: [],
  editMode: false,
  leftSection: null,
  description: '',
  className: 'flex flex-col gap-12 h-full',
  loading: false
}

PageLayout.displayName = 'PageLayout'
